import { createApp, ref, reactive, onMounted } from 'vue'

const app = createApp({
  setup() {
    let planSelectValue = reactive([])
    let buttonStatement = ref('')
    let fashionFlowerStatement = ref('')

    onMounted(() => {
      const selectArray = document.querySelectorAll('.c-select-box--plan')
      for (let i = 0; i < selectArray.length; i++) {
        planSelectValue[i] = selectArray[i].value
      }
      if (planSelectValue[1] === '1') {
        fashionFlowerStatement.value = true
      } else {
        fashionFlowerStatement.value = false
      }
      const judgeArray = planSelectValue.filter((value) => {
        value === 0
      })
      if (judgeArray.length === 0) {
        buttonStatement.value = true
      } else {
        buttonStatement.value = false
      }
    })
    const planSelectChange = (event, number) => {
      planSelectValue[number] = String(event.target.value)
      if (planSelectValue[1] === '1') {
        fashionFlowerStatement.value = true
      } else {
        fashionFlowerStatement.value = false
      }
      if (planSelectValue.includes('0')) {
        buttonStatement.value = false
      } else {
        buttonStatement.value = true
      }
    }
    return { planSelectValue, planSelectChange, fashionFlowerStatement, buttonStatement }
  }
})
if (document.querySelector('#planControl')) {
  app.mount('#planControl')
}
